enum FilterPopoverTabs {
  Clients,
  Advertisers,
  Campaigns,
  Events,
}

export default FilterPopoverTabs;
